import { render, staticRenderFns } from "./Contacto.vue?vue&type=template&id=1488fd9c"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"
import style0 from "./Contacto.vue?vue&type=style&index=0&id=1488fd9c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1488fd9c')) {
      api.createRecord('1488fd9c', component.options)
    } else {
      api.reload('1488fd9c', component.options)
    }
    module.hot.accept("./Contacto.vue?vue&type=template&id=1488fd9c", function () {
      api.rerender('1488fd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/landingPage/Contacto.vue"
export default component.exports